/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IUpdateProfileMethods,
  UpdateProfileService,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  IMyProfileCardMethods,
  MyProfileCardService,
  UserListsService,
  IUserListsMethods,
  IUserSearchMethods,
  UserSearchService,
  ISuspendUserMethods,
  SuspendUserService,
  ActivateUserService,
  IActivateUserMethods,
  IUpdateRolesMethods,
  UpdateRolesService,
  IGetRolesMethods,
  GetRolesService
} from "./components";

export type ViewBoxDetailPageAgent = IHeaderMethods &
  IUpdateProfileMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IUserListsMethods &
  ISettingsMethods &
  ISuspendUserMethods &
  IActivateUserMethods &
  IUserSearchMethods &
  IUpdateRolesMethods &
  IGetRolesMethods &
  IMyProfileCardMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new UpdateProfileService(),
    new StaticPageContentService(),
    new LoadingService(),
    new UserListsService(),
    new SettingsService(),
    new UserSearchService(),
    new SuspendUserService(),
    new ActivateUserService(),
    new MyProfileCardService(),
    new UpdateRolesService(),
    new GetRolesService(),
  ];
};

export const getAgent = () => {
  return createAgent<ViewBoxDetailPageAgent>({
    plugins: getPlugins(),
  });
};
